// extracted by mini-css-extract-plugin
export default {"sendbutton":"ec6067d00c5bdeefa9d8"};